import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {AdminCreationDatamodel} from '../datamodel/admin-creation.datamodel';
import {AccountCreationService} from '../services/account-creation.service';
import {User} from 'web-common/src/app/user/user';
import {ActivatedRoute} from '@angular/router';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {RolesModalComponent} from './admin-creation-modal/roles-modal/roles-modal.component';
import {AoFModalComponent} from './admin-creation-modal/aof-modal/aof-modal.component';
import {NotificationsService} from 'web-common/src/app/notifications.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-admin-creation',
  templateUrl: './admin-creation.component.html',
  styleUrls: ['./admin-creation.component.less', '../app.component.less']
})

export class AdminCreationComponent implements OnInit, OnDestroy {
  adminUser: User;
  gotData = false;
  creation: AdminCreationDatamodel;
  modalRef: BsModalRef;
  maxLengthRolesExceeded = false;
  maxLengthAofExceeded = false;
  chosenRoles = '';
  chosenAreaOfFocus = '';
  private stop$: Subject<any> = new Subject<any>();
  private originalRoles = '';


  constructor(
    private route: ActivatedRoute,
    private accountCreationService: AccountCreationService,
    private modalService: BsModalService,
    private notifications: NotificationsService
  ) {
  }

  ngOnInit() {
    this.adminUser = this.route.parent.snapshot.data['user'] as User;
    const that = this;
    this.accountCreationService.updatedRoles.pipe(takeUntil(this.stop$)).subscribe(() => {
      that.chosenRoles = that.accountCreationService.getChosenRoles().join('\n');
      that.originalRoles = this.chosenRoles;
      this.gotData = true;
    });
    this.accountCreationService.updatedAreas.pipe(takeUntil(this.stop$)).subscribe(() => {
        that.chosenAreaOfFocus = that.accountCreationService.getChosenAreaOfFocus().join('\n');
      }
    );
    this.accountCreationService.initializeRolesAndAreasOfFocus().pipe(takeUntil(this.stop$)).subscribe();
  }

  ngOnDestroy() {
    this.stop$.next();
    this.stop$.complete();
  }

  checkMaxLength(event, type) {
    if (!this.gotData) {
      return;
    }

    if (type === 'roles') {
      let text = this.chosenRoles.split('\n');
      for (let i = 0; i < text.length; i++) {
        if (text[i].length > 50) {
          this.maxLengthRolesExceeded = true;
          return;
        }
      }
    }
    if (type === 'aof') {
      let text = this.chosenAreaOfFocus.split('\n');
      for (let i = 0; i < text.length; i++) {
        if (text[i].length > 50) {
          this.maxLengthAofExceeded = true;
          return;
        }
      }
    }
    this.maxLengthRolesExceeded = false;
    this.maxLengthAofExceeded = false;
  }


  sortRoles() {
    this.chosenRoles = this.accountCreationService.cleanEmptySpaces(this.chosenRoles.split('\n')).join('\n');
    const aux = this.chosenRoles.split(/\s*\n\s*/);
    this.chosenRoles = aux.sort((a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'})).join('\n');
  };

  sortAreaOfFocus() {
    this.chosenAreaOfFocus = this.accountCreationService.cleanEmptySpaces(this.chosenAreaOfFocus.split('\n')).join('\n');
    const aux = this.chosenAreaOfFocus.split(/\s*\n\s*/);
    this.chosenAreaOfFocus = aux.sort((a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'})).join('\n');
  }

  checkIfEmptyRoles() {
    return this.gotData && this.chosenRoles.trim() === '';
  }

  openRolesModal() {
    document.getElementById('roles-open-modal-btn').blur();
      this.accountCreationService.updateChosenRoles(this.chosenRoles.split('\n'));
      const modalConfig = {
        class: 'modal-md',
        data: {type: 'roles'}
      };
      this.modalRef = this.modalService.show(RolesModalComponent, modalConfig);
  }

  openAreasModal() {
    document.getElementById('aof-open-modal-btn').blur();
      this.accountCreationService.updateChosenAreaOfFocus(this.chosenAreaOfFocus.split('\n'));
      const modalConfig = {
        class: 'modal-md',
        data: {type: 'aof'}
      };
      this.modalRef = this.modalService.show(AoFModalComponent, modalConfig);
  }

  private saveSuccess = () => {
    this.notifications.clearAll();
    this.notifications.success('Changes Saved Successfully.');
  }

  private showError = () => {
    this.notifications.error('Changes are not saved.', 'Error');
    if (this.chosenRoles.length === 0) {
      this.chosenRoles = this.originalRoles;
    }
  }

  save() {
    if (this.maxLengthRolesExceeded || this.maxLengthAofExceeded) {
      this.notifications.error('Each entry should be up to 50 characters.');
    } else if (this.checkIfEmptyRoles()) {
      this.showError();
    } else {
        this.accountCreationService.saveRolesAndAreasOfFocus(this.chosenRoles.split('\n'), this.chosenAreaOfFocus.split('\n')).subscribe(
          this.saveSuccess,
          this.showError
        );
    }
  }
}
